export default __webpack_public_path__ + "static/order-old-e597c6333b7cc2c3a1cef5c0cf54f409.png";